module.exports = __webpack_public_path__ + "static/media/1018405.5ac8653e.jpg";